import $ from 'jquery';

let Fetch = async (url, option = {}) => {
  if (window.localStorage.getItem('token')) {
    if (!option.body) {
      option.body = {};
    }
    option.body.token = window.localStorage.getItem('token');
    option.body.userId = window.localStorage.getItem('userId');
  }
  return new Promise((resolve, reject) => {
    $.ajax({
      url: `${SETTING.apiHost}${url}`,
      method: 'POST',
      data: option.body,
      success(e) {
        if (typeof e == 'object') {
          if (e.returnCode == 'QUERY_012') {
            Fetch.cbTokenOut && Fetch.cbTokenOut(e);
          }
          resolve(e);
        } else {
          if (JSON.parse(e).returnCode == 'QUERY_012') {
            Fetch.cbTokenOut && Fetch.cbTokenOut(JSON.parse(e));
          }
          resolve(JSON.parse(e));
        }
        // token 失效
      },
      error(e) {
        Fetch.cbError && Fetch.cbError(JSON.parse(e));
        reject(JSON.parse(e));
      }
    });
  });
};
export default Fetch;



// WEBPACK FOOTER //
// ./src/until/fetch.js